import styled from "styled-components";

export const SurveyContainer = styled.div`
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  position: relative;
  font-family: "Raleway", sans-serif;
  overflow-x: hidden;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
`;

export const ModuleContainer = styled.div`
  position: fixed;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0; 
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  max-height: 100vh;
  overflow: hidden;
  z-index: 3;

  @media (max-height: 875px) and (max-width: 768px) {
    align-items: flex-start;
    top: 125px;
    max-height: calc(100vh - 125px);
  }

  @media (max-height: 750px) and (max-width: 768px) {
    align-items: flex-start;
    top: ${(props) => (props.selected == "categories" ? "75px" : "125px")};
    max-height: calc(100vh - 125px);
  }

  @media (max-height: 550px) {
    align-items: flex-start;
    top: 75px;
    max-height: calc(100vh - 75px);
  }
`;

export const Back = styled.div`
  position: absolute;
  left: 28px;
  top: 20px;
  cursor: pointer;
  font-size: 20px;
  width: 50px;
  height: 50px;
  z-index: 2;
  color: #2a3039;
`;
